import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { ThemesGuard } from '../themes/guards/themes.guard';
import { StoryDetailComponent } from './containers/story-detail/story-detail.component';
import { StoriesOverviewComponent } from './containers/stories-overview/stories-overview.component';
import { StoryDetailGuard } from './guards';
import { StoryDetailMetaGuard } from './guards/stories-detail-meta.guard';
import { StoriesOverviewGuard } from './guards/stories.guard';
import { RelatedStoriesGuard, RelatedInitiativesGuard, RelatedContentGuard } from '../content/guards';
import { StoriesMapComponent } from './containers/stories-map/stories-map.component';

const routes: Routes = [
  {
    path: '',
    component: StoriesOverviewComponent,
    pathMatch: 'full',
    canActivate: [StoriesOverviewGuard, ThemesGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'kaart',
    component: StoriesMapComponent,
    pathMatch: 'full',
    canActivate: [ThemesGuard],
  },
  {
    path: ':storyId/:title',
    component: StoryDetailComponent,
    canActivate: [StoryDetailGuard, StoryDetailMetaGuard, RelatedStoriesGuard, RelatedInitiativesGuard, RelatedContentGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StoriesRoutingModule {}
